(function () {

var revealEls = Array.prototype.slice.call(document.querySelectorAll("[data-reveal]"));
  function revealInView() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    revealEls = revealEls.filter(function (el) {
      if (el.classList.contains("revealed")) return false;
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.95 && r.bottom > 0) { el.classList.add("revealed"); return false; }
      return true;
    });
  }
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("revealed"); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("revealed"); });
    revealEls = [];
  }
  revealInView();
  window.addEventListener("scroll", revealInView, { passive: true });
  document.addEventListener("visibilitychange", revealInView);
  setTimeout(revealInView, 600);
  setTimeout(function () {
    revealEls.forEach(function (el) { el.classList.add("revealed"); });
    revealEls = [];
  }, 2500);

  })();